/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import { RenderLeafProps } from "slate-react";
import styled from "styled-components";

import { Tooltip } from "src/components/UI/Tooltip";
import { CustomText } from "src/declare";

/**
 * Leaf is a slate term referring to a chunk of text with the same formatting applied
 */
export const Leaf = (props: RenderLeafProps) => {
  let { children, attributes } = props;
  const leaf = props.leaf as CustomText;

  if (leaf.email) {
    children = (
      <Tooltip tooltipText={`Email: ${leaf.text}`}>
        <div onClick={() => (window.location.href = `mailto:${leaf.text}`)}>
          <LinkStyles>{children}</LinkStyles>
        </div>
      </Tooltip>
    );
  } else if (leaf.link) {
    const validLinkUrl =
      leaf.text.slice(0, 8) === "https://" || leaf.text.slice(0, 7) === "http://"
        ? leaf.text
        : `http://${leaf.text}`;
    children = (
      <Tooltip tooltipText={`Link: ${typeof leaf.link === "string" ? leaf.link : leaf.text}`}>
        <div onClick={() => window.open(typeof leaf.link === "string" ? leaf.link : validLinkUrl)}>
          <LinkStyles>{children}</LinkStyles>
        </div>
      </Tooltip>
    );
  }

  return (
    <StyledLeaf leaf={leaf} {...attributes}>
      {children}
    </StyledLeaf>
  );
};

const StyledLeaf = styled.span<{ leaf: CustomText }>`
  /* mark styles */
  font-family: ${({ leaf }) => (leaf.font ? leaf.font : "inherit")};
  font-weight: ${({ leaf }) => (leaf.bold ? "bold" : "inherit")};
  font-style: ${({ leaf }) => (leaf.italic ? "italic" : "inherit")};
  text-decoration: ${({ leaf }) => (leaf.underline ? "underline" : "inherit")};
`;

const LinkStyles = styled.div`
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
  color: ${({ theme }) => theme.text.url};
`;
